/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import injectJss from 'react-jss';
import HeadingForm from '../../layout/HeadingForm';
import { mapClaimData } from '../../services';
import ContentWrapper from '../../components/ContentWrapper/ContentWrapper';
import ErgoNavButton from '../../components/ErgoNavButton';
import { legalConsentProps } from '../../models/panels';
import { getHeadingData } from '../../helpers/formData/vehicleFormData';
import { extractTemplateData } from '../../helpers/pdfHelpers';
import { logger } from '../../helpers/logger';
import styles from './styles.jss';
import {
  ContactDetails,
  IncidentDetails,
  PoliceDetails,
  FileDetails,
  RepairDetails,
  PayingOutDetails,
  VehicleDamageDetails,
  DamageOfAccidentDetails,
  ContactOfAccidentDetails,
} from './sections';
import ChevronLeftIcon from '@eg/elements/Icons/ChevronLeftIcon';

class VehicleSummaryPage extends React.PureComponent {
  state = {
    mappedFormData: {},
  };

  componentDidMount() {
    const { formData } = this.props;
    logger.log(formData, "FORM_DATA");
    this.setState({ mappedFormData: mapClaimData(formData).data },
      () => extractTemplateData('summaryPageWrapper'));
  }

  render() {
    const {
      isValid, localePath, classes, onClick,
    } = this.props;
    const { mappedFormData } = this.state;
    const { t } = this.context;
    const defaultProps = {
      formData: mappedFormData,
      localePath,
      className: classes.detailsWrapper,
    };

    return (
      <ContentWrapper>
        <HeadingForm
          value={t(`${localePath}.heading`, {
            fullName: getHeadingData(mappedFormData),
          })}
          commentValue={t(`${localePath}.comment`)}
        />
        <div id="summaryPageWrapper">
          <ContactDetails {...defaultProps} />
          <IncidentDetails {...defaultProps} />
          <PoliceDetails {...defaultProps} />
          <VehicleDamageDetails {...defaultProps} />
          <ContactOfAccidentDetails {...defaultProps} />
          <DamageOfAccidentDetails {...defaultProps} />
          <PayingOutDetails {...defaultProps} />
          <RepairDetails {...defaultProps} />
          <FileDetails {...defaultProps} />
        </div>

        <div className="esc_grid">
          <div className={`esc_grid__wrapper ${classes.gridWrapper}`}>
            <div className="esc_col esc_col-12 esc_col-s-3 esc_col-m-4">
              <ErgoNavButton variant="secondary" previous onClick={onClick} iconLeft={ChevronLeftIcon} shouldNavigateAfterClick type="submit" />
            </div>
            <div className="esc_col esc_col-12 esc_col-s-8 esc_col-m-4">
              <ErgoNavButton
                title={`${localePath}.ok`}
                onClick={onClick}
                disabled={!isValid}
                shouldNavigateAfterClick
                type="submit"
              />
            </div>
          </div>
        </div>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = ({ formData }) => ({ formData });

VehicleSummaryPage.propTypes = legalConsentProps.props;
VehicleSummaryPage.defaultProps = legalConsentProps.defaultProps;
VehicleSummaryPage.contextTypes = {
  t: PropTypes.func,
};

export { VehicleSummaryPage as VehicleSummaryPagePlain };
export default compose(
  connect(
    mapStateToProps,
    null,
  ),
  injectJss(styles),
)(VehicleSummaryPage);
